// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","info":"Header_info__hTX7k","form-type":"Header_form-type__YuAIH"};